import React from 'react'
import _ from 'underscore'
import EnquiryCoachbitOrderPartial from './partial'

class EnquiryCoachbitOrders extends React.Component {

  render() {
    return (
      <div className="coachbit-orders">
        {_.map(this.props.orders, (order) => (
          <EnquiryCoachbitOrderPartial
            key={order.id}
            order={order}
            enquiry_id={this.props.enquiry_id}
            onOpen={this.props.onOpen}
          />
        ))}
      </div>
    )
  }
}

export default EnquiryCoachbitOrders
